import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PdfFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PdfFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M13.65 19.81v-1.12c-.02-.96-.8-1.73-1.76-1.74h-.1v4.68h.1a1.78 1.78 0 0 0 1.76-1.78v-.03Zm-6.26-1.03c.36 0 .65-.29.65-.65v-.57a.655.655 0 0 0-.65-.61H6.17v1.87h1.22zm-.28 5.61v1.87c0 2.2 1.73 3.74 4.21 3.74h14.02c2.48 0 4.21-1.54 4.21-3.74V10.54c-.03-.12-.07-.24-.12-.34s0-.07 0-.07c-.06-.12-.14-.21-.22-.3l-7.54-7.5c-.09-.09-.19-.16-.3-.22s-.08 0-.08 0c-.08-.04-.17-.07-.27-.1s-9.69 0-9.69 0c-2.3 0-4.17 1.85-4.21 4.14v7.96H4.31c-1.03 0-1.87.84-1.87 1.87v6.55c0 1.03.84 1.87 1.87 1.87h2.81Zm0-8.42h.28c.88 0 1.59.71 1.59 1.59v.57c0 .88-.71 1.59-1.59 1.59H6.17v2.34a.49.49 0 0 1-.98 0v-5.61c0-.26.21-.47.47-.47H7.1Zm13.1.47c0 .26-.21.47-.47.47H17.4v1.87h2.34a.49.49 0 0 1 0 .98H17.4v2.34a.49.49 0 0 1-.98 0v-5.65c0-.26.21-.47.47-.47h2.85c.26 0 .47.21.47.47Zm-5.58 2.25v1.12c0 1.49-1.22 2.7-2.71 2.71h-.6a.47.47 0 0 1-.47-.47v-5.61c0-.26.21-.47.47-.47h.58c1.5 0 2.72 1.22 2.72 2.72ZM9.92 6.15c0-.77.63-1.4 1.4-1.4h7.95V9.9c0 1.29 1.05 2.34 2.34 2.34h5.15v14.03c0 .77-.76.97-1.4.97H11.33c-.64 0-1.4-.17-1.4-.97V24.4h11.23c1.03 0 1.87-.84 1.87-1.87v-6.55c0-1.03-.84-1.87-1.87-1.87H9.93V6.16Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M3 17.86c-.63 0-1.14-.51-1.14-1.14V5.29c0-1.89 1.54-3.43 3.43-3.43H19c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.81-8.81H5.29c-.63 0-1.14.51-1.14 1.14v11.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 17.86c-.63 0-1.14-.51-1.14-1.14v-3.43h-5.71c-1.89 0-3.43-1.54-3.43-3.43V3a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14ZM3.99 20.35h3.9c1.74 0 2.97 1.25 2.97 3s-1.24 3.03-2.97 3.03H6.27v2.91H3.99zm4.55 3.01c0-.65-.41-1.14-1.16-1.14h-1.1v2.26h1.1c.75 0 1.16-.47 1.16-1.12M11.9 20.35h3.62c2.63 0 4.51 1.79 4.51 4.47s-1.85 4.47-4.51 4.47H11.9zm5.79 4.47c0-1.38-.87-2.37-2.21-2.37h-1.3v4.75h1.3c1.34 0 2.21-1 2.21-2.38M21.06 20.35h6.09v2.06h-3.81V24h3.2v1.94h-3.2v3.34h-2.28z"
      })]
    })
  }));
};
PdfFileIcon.displayName = 'PdfFileIcon';